<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import addedit from "./addedit";
import osozlesme from "@/models/osozlesme"; 
export default {
  mixins: [Api, Sabit, osozlesme],
  page: {
    title: "Sözleşme Durumları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    addedit, 
  },
  data() {
    return {
      title: "Sözleşme Durumları",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Sözleşme Durumları",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      loading: true,
      APPLICATION_TYPE: JSON.parse(localStorage.getItem('config')).APPLICATION_TYPE,
      FILES_URL: JSON.parse(localStorage.getItem("config")).FILES_URL,
      Filter: {
        Baslik: null,
        Uygulamaid: null,
        Birimid: null,
        Baslangictarihi: null,
        Bitistarihi: null,
        Sozlesmeaktif: true,
      },
    };
  },

  methods: {
    Get() {


      var FilterText = "&Desc="

      if (this.Filter.Sozlesmeaktif !== null) {
        FilterText += "&Sozlesmeaktif=" + this.Filter.Sozlesmeaktif
      }

      this.ActionsFilterGet({
        Service: "OBirim/GetBirimSozlesme",
        Page: this.Page,
        Filter: FilterText,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.loading = false;
      });
    },

    ToggleSozlesmeAktif(Data) {
      this.UpdateIdsiz("OBirim/SozlesmeAktif", { Id: Data.Id, Sozlesmeaktif: !Data.Sozlesmeaktif });
    },

    getTarihClass(bitistarihi) {
      if (!bitistarihi) return "";

      const today = new Date();
      const bitis = new Date(bitistarihi);

      const diffDays = (bitis - today) / (1000 * 60 * 60 * 24);

      if (diffDays < 0) {
        return "table-danger";   
      } else if (diffDays <= 90) {
        return "table-warning";   
      } else {
        return "table-success";  
      }
    }
    },
};
</script>

<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">

                <div class="col-sm-8 row">

                  <b-form-group class="col-lg-3" label="Sözleşme Durumu">
                    <select class="form-select" v-model="Filter.Sozlesmeaktif">
                      <option :value="true">Aktif</option>
                      <option :value="false">Pasif</option>
                      <option :value="null">Tümü</option>
                    </select>
                  </b-form-group>

                  <div class="col-lg-3 mt-4">
                    <button class="btn btn-success" type="button" @click="Page.PageNumber = 1, Get()">
                      Filtreleme
                    </button>
                  </div>

                </div>

              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Kurum</th>
                      <th>Uygulamalar</th>
                      <th>Sözleşme Uygulamalar</th>
                      <th>Sözleşme</th>
                      <th>Başlangıç Tarihi</th>
                      <th>Bitiş Tarihi</th>
                      <th>Tutar</th>
                      <th>Sözleşme Durumu</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id" :class="getTarihClass(Data.Bitistarihi)">
                      <th scope="row">{{ Data.Kurum }}</th>
                      <td style="max-width: 400px;">{{ Data.Uygulamalar }}</td>
                      <td style="max-width: 400px;">{{ Data.Sozlesmeuygulamalar }}</td>
                      <td>{{ Data.Baslik }}</td>
                      <td>{{ Data.Baslangictarihi != null ? formatDateTable(Data.Baslangictarihi) : '' }}</td>
                      <td>{{ Data.Bitistarihi != null ? formatDateTable(Data.Bitistarihi) : '' }}</td>
                      <td>{{ Data.Tutar ? TrParaFormat(Data.Tutar) + ' ₺' : '' }}</td>
                      <td>
                        <b-button
                          size="sm"
                          :variant="Data.Sozlesmeaktif ? 'success' : 'danger'"
                          v-b-tooltip.hover
                          title="Değiştirmek için tıklayın"
                          @click="ToggleSozlesmeAktif(Data)"
                        >
                          {{ Data.Sozlesmeaktif ? 'Aktif' : 'Pasif' }}
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
                  @page-click="ChangePage($event, (Page.PageDataSize / Page.PageSize))">
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <addedit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
    </Layout>
  </Loader>
</template>
